import React, { useRef } from 'react'

const Form = ({ children, submit, typeData, loading = "Loading ..." }) => {
    const form = useRef();
   
    let inputs = new FormData();
    if (typeData === 'object') {
        inputs = {};
    }

    const Send = async (data) => {
        return await submit(data)
    }

    const Submit = (e) => {
        e.preventDefault()
        const Button = form.current.querySelector('button[type="submit"]');

        const ButtonHtml = Button.innerHTML;
        Button.disabled = true;
        Button.innerHTML = loading;

        for (const [key, input] of Object.entries(form.current.querySelectorAll('input,select'))) {
            if (String(input.name).length) {
                if (typeData === 'object') {
                    inputs[input.name] = input.value;
                } else {
                    if (input.type == 'radio') {
                        if (input.checked) {
                            inputs.append(
                                input.name,
                                input.value
                            )
                        }
                    } else {
                        if (input.type === 'file') {
                            if (input.files[0]) {
                                inputs.append(
                                    input.name,
                                    input.files[0]
                                )
                            }
                        } else {
                            if (typeof value === 'object') {
                                for (const ob of Object.entries(input.value)) {
                                    if (ob[1]) {
                                        inputs.append(
                                            input.name + '[]',
                                            ob[1]
                                        )
                                    }
                                }
                            } else {
                                if (input.value) {
                                    inputs.append(
                                        input.name,
                                        input.value
                                    )
                                }
                            }
                        }
                    }
                }

            }
        }

        Send(inputs).then(() => {
            Button.disabled = false;
            Button.innerHTML = ButtonHtml;
            if (typeData === 'object') {
                inputs = {};
            } else {
                inputs = new FormData();
            }
        });
    }
    return (
        <form ref={form} onSubmit={Submit} >
            {children}
        </form >
    )
}
export default Form;